import {AxiosResponse} from 'axios';
import {call, put, select} from 'redux-saga/effects';
import {getBeersList} from 'services/beers';
import {getPubBeersData} from 'services/pubs';
import {handleError} from 'store/app/error/saga';
import ApiData from 'typescript/interfaces/ApiData';
import {Beer} from 'typescript/models/Beer';
import {PubBeer} from 'typescript/models/PubBeer';

import {getPubBeersACS, getAllBeersACS} from '../requestAC';
import {
  setAllBeersAC,
  setBeersBreweriesIncludedAC,
  setBeersTotalPagesAC,
  setCurrentPageAC,
  setPubBeersAC,
  setTotalPagesAC,
} from '../slice';

export function* getPubBeers(action: ReturnType<typeof getPubBeersACS>) {
  try {
    const response: AxiosResponse<ApiData<PubBeer[]>> = yield call(getPubBeersData, action.payload);

    const {
      data,
      meta: {total_pages, current_page},
    } = response.data;

    yield put(setPubBeersAC(data));
    yield put(setCurrentPageAC(current_page));
    yield put(setTotalPagesAC(total_pages));
  } catch (error) {
    yield call(handleError, error, 'Failed to get pub beers');
  }
}

export function* getAllBeers(action: ReturnType<typeof getAllBeersACS>) {
  const allBeers: Beer[] = yield select((state) => state.beersManager.allBeers);

  try {
    const response: AxiosResponse<ApiData<Beer[]>> = yield call(getBeersList, action.payload);
    const {
      data,
      meta: {total_pages, current_page},
      included,
    } = response.data;

    let beerList: Beer[];
    if (action.payload.name) {
      if (action.payload.page > 1) beerList = [...allBeers, ...data];
      else beerList = data;
    } else beerList = [...allBeers, ...data];

    yield put(setAllBeersAC(beerList));
    yield put(setCurrentPageAC(current_page));
    yield put(setBeersTotalPagesAC(total_pages));
    if (included.length) {
      const filteredIncluded = included.filter((item) => item.type !== 'beer_styles');
      yield put(setBeersBreweriesIncludedAC(filteredIncluded));
    }
  } catch (error) {
    yield call(handleError, error, 'Failed to get beers');
  }
}
